import axios from "axios";
import qs from "qs";
const test = "//cldjadm.ynbzde.com/"; // 测试域名
// AJAX请求对象
const service = axios.create({
  baseURL: test,
  transformRequest: [
    function(data) {
      return qs.stringify(data);
    }
  ],
  headers: { "Content-Type": "application/x-www-form-urlencoded" }
});
// 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 1) {
      return response.data.data;
    }
    if (response.data.code === 401) {
      //return response.data.data;
      throw new Error(response.data.msg);
    } else {
      throw new Error(response.data.msg);
    }
  },
  error => {
    const msg = error.response.data.msg;
    if (error.response.status === 401) {
      throw new Error(msg);
    }
    throw new Error(msg ? msg : "服务器发生错误");
  }
);
const api = {
  // 获得登录用二维码
  getForQrCode() {
    return service.get("api/wechat/logincode");
  },
  // 获得首页数据
  getHomeData(status, keyword, page) {
    return service.get(
      "api/index/infoList" +
        "?status=" +
        status +
        "&keyword=" +
        keyword +
        "&page=" +
        page
    );
  },
  // 从微信二维码的state登录
  loginForState(state) {
    return service.post("api/wechat/checkLogin", {
      state
    });
  },
  // 发送手机验证码
  sendMsg(mobile, event) {
    return service.post("api/sms/send", {
      mobile,
      event
    });
  },
  // 修改密码
  changpwd(token, oldpwd, password, confirmpwd) {
    return service.post("api/user/changpwd", {
      token,
      oldpwd,
      password,
      confirmpwd
    });
  },
  // 验证手机号验证码是否正确
  smsCheck(token, event, captcha) {
    return service.post("api/sms/check", {
      token,
      event,
      captcha
    });
  },
  // 修改手机号码
  changemobile(token, mobile, captcha) {
    return service.post("api/user/changemobile", {
      token,
      mobile,
      captcha
    });
  },
  // 手机号和验证码的登录界面
  loginForMobile(mobile, captcha, state) {
    const data = {
      mobile,
      captcha
    };
    if (state) {
      data.state = state;
    }
    return service.post("api/user/mobilelogin", data);
  },
  // 用户名和密码的登录界面
  login(account, password, state) {
    const data = {
      account,
      password
    };
    if (state) {
      data.state = state;
    }
    return service.post("api/user/login", data);
  },
  // 注册接口
  register(username, password, code, mobile, confirmpwd, state, company_name) {
    const data = {
      username,
      password,
      code,
      mobile,
      confirmpwd,
      company_name
    };
    if (state) {
      data.state = state;
    }
    return service.post("api/user/register", data);
  },
  // 找回密码
  resetpwd(mobile, captcha, password, confirmpwd) {
    return service.post("api/user/resetpwd", {
      mobile,
      captcha,
      password,
      confirmpwd
    });
  },
  // 用户协议
  agreement() {
    return service.get("api/user/agreement");
  },
  // 获得新闻列表
  getNewslist(token, status, page) {
    return service.post("api/letter/index", {
      token,
      status,
      page
    });
  },
  // 消息通知详情
  getNewsdetail(token, id) {
    return service.post("api/letter/detail", {
      token,
      id
    });
  },
  // 获得企业分类
  getQyFl(type, pid) {
    return service.post("api/category/selectpage", {
      custom: {
        type,
        pid
      }
    });
  },
  // 保存企业信息/保存经销（代理）商信息
  saveProfile(token, data, agent) {
    if (agent) {
      return service.post("api/user/agentSub", {
        token,
        ...data
      });
    } else {
      return service.post("api/user/profile", {
        token,
        ...data
      });
    }
  },
  // 会员基本信息
  userinfo(token, agent) {
    if (agent) {
      return service.post("api/user/agent", {
        token
      });
    } else {
      return service.post("api/user/userinfo", {
        token
      });
    }
  },
  // 建材分类接口
  buidCates(parent_id) {
    return service.post("api/category/buidCates", {
      parent_id
    });
  },
  // 产品信息的大表单提交
  infoSub(token, data) {
    return service.post("api/infomation/infoSub", {
      token,
      ...data
    });
  },
  // 产品信息补充
  repairSub(token, data) {
    return service.post("api/infomation/repairSub", {
      token,
      ...data
    });
  },
  // 获取提交的大表单信息
  infodetail(token, uuid) {
    return service.post("api/infomation/detail", {
      token,
      uuid
    });
  },
  // 删除信息
  infomationDelete(token, uuid) {
    return service.post("api/infomation/delete", {
      token,
      uuid
    });
  },
  // 产品分类详情
  buidDetail(id) {
    return service.post("api/category/buidDetail", {
      id
    });
  },
  // 获得单位信息
  getUnits() {
    return service.post("api/common/units");
  },
  // 获得Excel表形式分类结构
  getExcelCLassLi() {
    return service.post("api/category/buidCateLi");
  },
  // 材料信息列表页
  infomationIndex(token, status, createtime, keyword, page) {
    return service.post("api/infomation/index", {
      token,
      status,
      createtime,
      keyword,
      page
    });
  },
  // 新闻列表
  getNewList(keyword, listrow) {
    return service.post("api/notices/index", {
      keyword,
      listrow
    });
  },
  // 新闻详情
  getInfo(id) {
    return service.post("api/notices/detail", {
      id
    });
  },
  // 飘窗接口
  getPiaochuang() {
    return service.post("api/index/windows");
  },
  // 获得生产厂商列表
  agentLi(token, profile_step, id) {
    if (!profile_step) {
      profile_step = null;
    }
    if (!id) {
      id = null;
    }
    return service.post("api/user/agentLi", {
      token,
      profile_step,
      id
    });
  },
  // 获得生产厂商详情
  getAgent(token, id) {
    return service.post("api/user/agent", {
      token,
      id
    });
  },
  // 删除生产厂商
  agentDelete(token, id) {
    return service.post("api/user/agentDelete", {
      token,
      id
    });
  },
  // 修改产品类型
  upType(token, uuid, type) {
    return service.post("api/Infomation/upType", {
      token,
      uuid,
      type
    });
  },
  // 确认并同意附件提交
  succSure(token, uuid, imsgfiles) {
    return service.post("api/infomation/succSure", {
      token,
      uuid,
      imsgfiles
    });
  },
  // 对信息表提出疑议
  errorSure(token, uuid, suremsg) {
    return service.post("api/infomation/errorSure", {
      token,
      uuid,
      suremsg
    });
  },
  // 告诉后端可以展示生产厂商信息
  firstin(token) {
    return service.post("api/user/firstin", {
      token
    });
  },
  // 获得审核中的显示内容
  shows(token, agent_type) {
    return service.post("api/index/shows", {
      token,
      agent_type
    });
  },
  // 确认产品规格型号
  passway(token, uuid, imsgfiles, attrspecs) {
    return service.post("api/infomation/passway", {
      token,
      uuid,
      imsgfiles,
      attrspecs
    });
  },
  // 获得大证书的信息
  suppercode(token, uuid, agentType) {
    return service.post("api/codes/suppercode", {
      token,
      uuid,
      agent_type: agentType
    });
  },
  // 证书的产品列表页面
  certificate(token, uuid, agent_type, page) {
    return service.post("api/codes/certificate", {
      token,
      uuid,
      agent_type,
      per_page: 15,
      page
    });
  },
  // 规格型号详情
  speciDetail(token, uuid) {
    return service.post("api/codes/speciDetail", {
      token,
      uuid
    });
  },
  // 规格型号详情
  feedBack(company_name, contact_name, contact_tel, back_file) {
    return service.post("api/index/feedback", {
      company_name,
      contact_name,
      contact_tel,
      back_file
    });
  },
  //批量导入产品
  importInsert(token, file) {
    return service.post("api/infomation/importInsert", { token, file });
  },
  //批量导入产品
  enableUse(token, uuid) {
    return service.post("api/infomation/enableUse", { token, uuid });
  },
  editQuality(formdata) {
    return service.post("api/infomation/editQuality", formdata);
  },
  getQuality(formdata) {
    return service.get("api/infomation/editQuality", formdata);
  },

  domain: test // 主域名
};
export default api;
